// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__LU-Bs","spin":"styles_spin__4Tfle"};